import React from "react";
import "./DashboardIsland.css";

export default function DashboardIsland({ children, title, icon, action }) {
  return (
    <section className="dashboard-island">
      <div className="dashboard-island-header">
        {/* Left: Icon + Title */}

          {title && <h2 className="dashboard-island-title">{title}</h2>}

        {/* Right: Optional action (like Invite button) */}
        {action && (
          <div className="dashboard-island-header-right">
            {action}
          </div>
        )}
      </div>

      <div className="dashboard-island-body">{children}</div>
    </section>
  );
}
